import {
	login,
	logout,
	getInfo
} from '@/api/login'
import {
	getToken,
	setToken,
	removeToken
} from '@/utils/auth'

const user = {
	state: {
		token: getToken(),
		name: '',
		avatar: '',
		roles: []
	},

	mutations: {
		SET_TOKEN: (state, token) => {
			state.token = token
		},
		SET_NAME: (state, name) => {
			state.name = name
		},
		SET_AVATAR: (state, avatar) => {
			state.avatar = avatar
		},
		SET_ROLES: (state, roles) => {
			state.roles = roles
		}
	},

	actions: {
		// 登录
		Login({
			commit
		}, userInfo) {
			const username = userInfo.loginName.trim()
			return new Promise((resolve, reject) => {
				login(username, userInfo.password).then(response => {
					const data = response.data
					const tokenStr = data.token
					setToken(tokenStr)
					commit('SET_TOKEN', tokenStr)
					resolve()
				}).catch(error => {
					reject(error)
				})
			})
		},


		// 获取用户信息
		GetInfo({
			commit,
			state
		}) {
			return new Promise((resolve, reject) => {
				// 先注释了
				getInfo().then(response => {
					const data = response.data
					if (data.roles && data.roles.length > 0) { // 验证返回的roles是否是一个非空数组
						commit('SET_ROLES', data.roles)
					} else {
						reject('getInfo: roles must be a non-null array !')
					}
					// var obj = {
					// 	checkedIcon: null,
					// 	children: null,
					// 	createBy: "init",
					// 	createTime: "2020-12-01 18:01:29",
					// 	icon: "bendidiaoyong",
					// 	id: 100,
					// 	level: 1,
					// 	name: "demo页面",
					// 	parentId: 50,
					// 	sort: null,
					// 	updateBy: null,
					// 	updateTime: null,
					// 	url: null,
					// 	value: "admin:staging:demo",
					// }
					// response.data1.push(obj);

					// 获取权限按钮存起来
					var listBtn = []
					response.data1.forEach((item, index) => {
						listBtn.push(item.value);
					});
					window.localStorage.setItem("btnPower", listBtn.join(','));
					console.log(response.data1, 'response.data1')

					commit('SET_NAME', data.name)
					commit('SET_AVATAR', data.headImage)
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},

		// 登出
		LogOut({
			commit,
			state
		}) {
			return new Promise((resolve, reject) => {
				logout(state.token).then(() => {
					commit('SET_TOKEN', '')
					commit('SET_ROLES', [])
					removeToken()
					resolve()
				}).catch(error => {
					reject(error)
				})
			})
		},

		// 前端 登出
		FedLogOut({
			commit
		}) {
			return new Promise(resolve => {
				commit('SET_TOKEN', '')
				removeToken()
				resolve()
			})
		}
	}
}

export default user


// WEBPACK FOOTER //
// ./src/store/modules/user.js